import React from 'react';
import { WxbCodeText } from '../Typography/Typography';
import './EntityHeader.css';

export interface WxbEntityMetaItem {
  key: string;
  label: React.ReactNode;
  value: React.ReactNode;
}

export interface WxbEntityHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  code?: React.ReactNode;
  status?: React.ReactNode;
  avatar?: React.ReactNode;
  meta?: WxbEntityMetaItem[];
  actions?: React.ReactNode;
  density?: 'comfortable' | 'compact';
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbEntityHeader: React.FC<WxbEntityHeaderProps> = ({
  eyebrow,
  title,
  subtitle,
  code,
  status,
  avatar,
  meta,
  actions,
  density = 'comfortable',
  className = '',
  ...props
}) => (
  <div className={joinClasses('wxb-entity-header', `wxb-entity-header-${density}`, className)} {...props}>
    {avatar && <div className="wxb-entity-avatar">{avatar}</div>}
    <div className="wxb-entity-main">
      {eyebrow && <div className="wxb-entity-eyebrow">{eyebrow}</div>}
      <div className="wxb-entity-title-row">
        <div className="wxb-entity-title">{title}</div>
        {code && <WxbCodeText compact>{code}</WxbCodeText>}
        {status && <div className="wxb-entity-status">{status}</div>}
      </div>
      {subtitle && <div className="wxb-entity-subtitle">{subtitle}</div>}
      {meta && meta.length > 0 && (
        <dl className="wxb-entity-meta">
          {meta.map((item) => (
            <div className="wxb-entity-meta-item" key={item.key}>
              <dt>{item.label}</dt>
              <dd>{item.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
    {actions && <div className="wxb-entity-actions">{actions}</div>}
  </div>
);

